LessonEngine   = require("models/lesson-engine")

class Lesson
  constructor: (conf) ->
    @loadConfiguration(conf) if conf?

  loadConfiguration: (conf) ->
    @configuration = conf
    @engine        = new LessonEngine(@configuration)

  loadFromConfigJsonFile: (done) ->
    ajaxParams = type: "GET", url: "config.json", dataType: "json"
    @request = $.ajax _.extend ajaxParams,
      success: (data) -> done(null, data)
      error: (err) -> done(err)

  loadFromSession: (done) ->
    { Session } = Application.actions()

    Session.waitAndGet (err, data) ->
      if err?
        done(err)
      else if not(data?.config)
        done(new Error("No slides configuration"))
      else
        window.setTimeout (-> done(null, data.config)), 100

  loadData: (done) ->
    if require('app')?.isPlayer
      return @loadFromSession(done)
    else
      return @loadFromConfigJsonFile(done)

  load: (done) ->
    @loadData (err, conf) =>
      if err?
        return done(err) if err?
      else
        @loadConfiguration(conf)
        done null, conf

  getState: ->
    @engine.getState()

  processInteraction: (i) ->
    @engine.processInteraction(i)

  getSlides: ->
    @engine.slides()

module.exports = Lesson
